var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileInfoInner.jinja');
require('./MemberProfileInfoInner.less');

module.exports = Base.extend({

    template: template,

    initialize: function (options) {
        this.options = options || {};
        var self = this;

        this.$('.MemberProfileInfoInner-info-selfLinks-link').each(function () {
            $(this).attr('href', self.addProtocol($(this).attr('href'), 'http', $(this).attr('data-tp')));
        });

        this.$('.MemberProfileInfoInner-info-social-link').each(function () {
            $(this).attr('href', self.addProtocol($(this).attr('href'), 'https', $(this).attr('data-tp')));
        });

        Base.prototype.initialize.call(this, options);
    },

    addProtocol: function (str, protocol, tp) {
        var res;

        //detect username only for social and imdb
        if (tp) {
            if (str.indexOf(tp + '.com') < 0) {
                if (tp == 'imdb') str = 'www.imdb.com/name/' + str;
                if (tp == 'facebook') str = 'www.facebook.com/' + str;
                if (tp == 'twitter') str = 'twitter.com/' + str;
                if (tp == 'instagram') str = 'www.instagram.com/' + str;
                if (tp == 'linkedin') str = 'www.linkedin.com/' + str;
                if (tp == 'vimeo') str = 'vimeo.com/' + str;
                if (tp == 'youtube') str = 'www.youtube.com/user/' + str;
            }
            protocol = 'https';
        }

        if (!/^http(s)?:\/\//.test(str) && str && !/^mailto\:/.test(str) && !/^tel\:/.test(str)) {
            res = protocol + '://' + str;
        } else {
            res = str;
        }

        return res;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileInfoInner.js
// module id = 192
// module chunks = 0